import React, { PureComponent } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numberWithCommas, mFormatter, kmFormatter } from "../../../../../../MainContent/Dashboard/Charts/utils";
import HighchartsCustomEvents from "highcharts-custom-events";
HighchartsCustomEvents(Highcharts);

class AudienceByCountryChart extends PureComponent {
    constructor(props) {
        super(props);
        this.chartComponent = React.createRef();
        this.legendAlign = this.props.isIGPage ? "right" : "center";
    }
    componentDidMount() {
        if (!this.props.isIGPage) {
            this.ro = new ResizeObserver(() => {
                this.chartComponent?.current?.chart?.setSize(null, null);
                this.chartComponent?.current?.chart?.reflow();
            });
            if (this.props.widgetContainerRef?.current) {
                this.ro.observe(this.props.widgetContainerRef?.current);
            }
        }
    }
    componentWillUnmount() {
        if (!this.props.isIGPage) {
            this.ro.disconnect();
        }
    }
    getBarOptions() {
        const barOptions = {
            chart: {
                type: "bar",
                className: "skiptranslate",
                backgroundColor: "transparent",
                events: {},
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: ``,
            },
            legend: {
                enabled: this.props.showLegend,
                align: this.legendAlign,
                alignColumns: false,
            },
            plotOptions: {
                series: {
                    stacking: "normal",
                },
                bar: {
                    shadow: false,
                    showInLegend: true,
                    dataLabels: {
                        enabled: this.props.showLabel,
                        formatter: function () {
                            return `<span>${kmFormatter(this.point.y)}</span>
                        `;
                        },
                        inside: false,
                        style: {
                            color: "#333333",
                        },

                        pointWidth: 15,
                        stacking: "normal",
                    },
                },
            },
            credits: {
                enabled: false,
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            xAxis: {
                categories: this.props.chartData.LocationWithData || [],
                type: "category",
                lineWidth: 1,
                // labels: {
                //     useHTML: true,
                //     style: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
                // },
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "shortdash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: "",
            },
            tooltip: {
                backgroundColor: "#fff",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "capitalize ",
                },
                formatter: function () {
                    return `<b>${this.point.name}</b> </br> <span>Audienece count</span> | <b> ${((this.y / this.point.options.total) * 100).toFixed(
                        2,
                    )}% | ${numberWithCommas(this.y)}/${numberWithCommas(this.point.options.total)}</b>`;
                },
            },
            series: this.props.chartData.barChartData || [],
        };
        return barOptions;
    }
    getPieOptions() {
        const pieOptions = {
            chart: {
                type: "pie",
                className: "skiptranslate",
                backgroundColor: "transparent",
                events: {},
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: "",
            },
            legend: {
                enabled: this.props.showLegend,
                align: this.legendAlign,
                itemStyle: {
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "capitalize ",
                },
                alignColumns: false,
            },
            credits: {
                enabled: false,
            },
            accessibility: {
                point: {
                    valueSuffix: "%",
                },
            },
            xAxis: {
                lineWidth: 0,
            },
            yAxis: {
                lineWidth: 0,
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: "pointer",
                    distance: "10%",
                    dataLabels: {
                        enabled: this.props.showLabel,
                        format: "<b>{point.name}</b>: {point.percentage:.1f} %",
                        style: {
                            fontWeight: 400,
                            color: "#333333",
                        },
                    },
                    showInLegend: this.props.showLegend,
                },
            },
            tooltip: {
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "capitalize ",
                },
                backgroundColor: "#fff",
                formatter: function () {
                    return `<b>${this.point.name}</b> </br> <span>Audienece count</span> | <b>${this.point.percentage.toFixed(1) + "%"} | ${numberWithCommas(
                        this.y,
                    )}/${numberWithCommas(this.point.total)}</b>`;
                },
            },
            series: [{ data: this.props.chartData.pieChartData }] || [],
        };
        return pieOptions;
    }
    render() {
        return (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.props.graphType == "bar" ? this.getBarOptions() : this.getPieOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: this.props.isIGPage ? "calc(100% - 30px)" : "calc(100% - 50px)" } }}
            />
        );
    }
}
export default AudienceByCountryChart;
